export default __webpack_public_path__ + "static/media/five.33208f34.jpg";